export enum TreeNodeRefreshOptions {
  'ALL',
  'NODE',
  'VIEW',
  'CHILDREN',
  'UPDATE_CHILDREN_COUNT',
  'FORCE_CLICK',
  'TOGGLE_EXPAND',
}
